"use client";

import Link from "next/link";
import Image from "next/image";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white ">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e descrição */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-6">
              <Image
                src="/mla.png" // Substitua pelo caminho correto do seu logo
                alt="MLA Organization"
                width={120}
                height={40}
                className="mb-4"
              />
              <p className="text-gray-400 max-w-md">
                Connecting cultures through professional audiovisual translation services worldwide.
              </p>
            </div>
          </div>

          {/* Links rápidos */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-yellow-500">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  href="#home" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  href="#about" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link 
                  href="#associates" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  Associates
                </Link>
              </li>
              <li>
                <Link 
                  href="#news" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors"
                >
                  News
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 text-yellow-500">Contact</h3>
            <div className="space-y-3 text-gray-400">
              <p>daniel@alcateiaaudiovisual.com.br</p>
              <p>Rua General Barbosa Lima 39, Rio de Janeiro</p>
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div className="border-t border-gray-800 my-8"></div>

        {/* Copyright e links secundários */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} MLA Organization. All rights reserved.
          </div>
          
          <div className="flex space-x-6">
            <Link 
              href="/privacy" 
              className="text-gray-400 hover:text-yellow-500 text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              href="/terms" 
              className="text-gray-400 hover:text-yellow-500 text-sm transition-colors"
            >
              Terms of Service
            </Link>
            <Link 
              href="/cookies" 
              className="text-gray-400 hover:text-yellow-500 text-sm transition-colors"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

